var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var ArrowRightIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 57,
    glyphHeight: 62
  }), React.createElement("path", {
    d: "M40.8 26.7998L22 6.7998L27.6 0.799805L56.2 31.1998L27.8 61.5998L22.2 55.5998L41 35.5998H0V26.9998L40.8 26.7998Z"
  }));
};
export var ArrowRightIconGlyph = function (props) {
  return React.createElement(ArrowRightIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};